module.exports = __webpack_public_path__ + "img/V0.56a06f5f.jpg";